import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ExpensesAdapter } from './dto/expenses-adapter';
import { Expenses } from './entity/expenses-entity';
import { ExpensesController } from './expenses.controller';
import { ExpensesService } from './expenses.service';

@Module({
  imports:[TypeOrmModule.forFeature([Expenses])],
  controllers: [ExpensesController],
  providers: [ExpensesService,ExpensesAdapter,ApplicationExceptionHandler],
  exports:[ExpensesService]
})
export class ExpensesModule {}
